import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Container } from "semantic-ui-react";

import request from "./utils/request";
import { apiUrl } from './utils/constants';
import JackpotKiosk from "./pages/JackpotKiosk";

function persistLoaderThemeFromSettings(settings) {
    try {
        if (!settings) return;
        const buildTheme = window.__bumpBuildLoaderThemeFromSettings;
        const persistTheme = window.__bumpPersistLoaderTheme;
        if (typeof buildTheme !== "function" || typeof persistTheme !== "function") return;
        const loaderTheme = buildTheme(settings);
        if (loaderTheme) persistTheme(loaderTheme);
    } catch (error) {
    }
}

class App extends Component {
    _mounted = false;
    state = {};

    componentDidMount = async () => {
        await apiUrl();
        this.getConfig();
        this._mounted = true;
    };

    componentWillUnmount = async() => {
        this._mounted = false;
    }

    getConfig = async () => {
        let settings = window.__bumpBootstrapSettings;

        if (!settings && window.__bumpBootstrapSettingsPromise && typeof window.__bumpBootstrapSettingsPromise.then === "function") {
            try {
                settings = await window.__bumpBootstrapSettingsPromise;
            } catch (error) {
            }
        }

        if (!settings) {
            settings = await request.get(this, "/settings/config", {});
        }

        persistLoaderThemeFromSettings(settings);

        this.setState({
            settings: settings
        });
        return true;
    };

    render() {
        const { settings } = this.state;

        if (!this._mounted) return <Container fluid />;

        return (
            <JackpotKiosk location={window.location} defaultJackpotId={settings ? settings.general.default_jackpot_id : 0} />
        );
    }
}

export default withRouter(App);
